import React from 'react';

interface Props extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  helperText?: string;
  error?: string | null;
}

const inputClass =
  'w-full px-4 py-2.5 bg-white border border-[var(--border)] rounded-lg text-sm focus:outline-none focus:border-[var(--accent)] focus:ring-4 focus:ring-[var(--accent)]/15 transition-all';

const TextField: React.FC<Props> = ({ label, helperText, error, id, className = '', ...rest }) => {
  const inputId = id ?? `tf-${rest.name ?? Math.random().toString(36).slice(2, 8)}`;
  return (
    <div>
      <label htmlFor={inputId} className="block text-sm font-medium text-[var(--text)] mb-1.5">
        {label}
      </label>
      <input id={inputId} className={`${inputClass} ${error ? 'border-red-300 focus:border-red-400 focus:ring-red-200' : ''} ${className}`} {...rest} />
      {(helperText || error) && (
        <p className={`mt-1.5 text-xs ${error ? 'text-red-700' : 'text-[var(--text-muted)]'}`}>{error || helperText}</p>
      )}
    </div>
  );
};

export default TextField;
